import { fetchPath } from "./fetch-path";

export function isVideo(src?: string): src is string {
  if (!src) return false;

  return /\.(mp4|mov|webm)$/i.test(fetchPath(src));
}
